import { render, staticRenderFns } from "./ResultsLayout.vue?vue&type=template&id=9c97db3a&"
import script from "./ResultsLayout.vue?vue&type=script&lang=ts&"
export * from "./ResultsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports